import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { StripeService } from '../services/stripe.service';

@Component({
  selector: 'app-reactivar-cliente-popup',
  templateUrl: './reactivar-cliente-popup.component.html',
  styleUrls: ['./reactivar-cliente-popup.component.scss']
})
export class ReactivarClientePopupComponent implements OnInit {
  @Input() cliente: any;
  @Input() isVisible: boolean = false;
  @Output() closeModal = new EventEmitter<void>();
  @Output() reactivarCliente = new EventEmitter<any>();

  public lastInvoice: any = null;
  public loadingInvoice: boolean = false;
  public selectedOption: string = 'mark_invoice_paid';
  public processing: boolean = false;
  public customerCreditBalance: any = null;
  public loadingCreditBalance: boolean = false;

  constructor(private stripeService: StripeService) { }

  ngOnInit() {
    // Component initialization
  }

  async ngOnChanges() {
    if (this.isVisible && this.cliente) {
      await Promise.all([
        this.loadLastInvoice(),
        this.loadCustomerCreditBalance()
      ]);
    }
  }

  async loadLastInvoice() {
    if (!this.cliente || !this.cliente.customer) {
      return;
    }

    this.loadingInvoice = true;
    try {
      this.lastInvoice = await this.stripeService.getLastInvoice(this.cliente.customer);
    } catch (error) {
      console.error('Error loading last invoice:', error);
      this.lastInvoice = null;
    } finally {
      this.loadingInvoice = false;
    }
  }

  async loadCustomerCreditBalance() {
    if (!this.cliente || !this.cliente.customer) {
      return;
    }

    this.loadingCreditBalance = true;
    try {
      const customer = await this.stripeService.getCustomerCreditBalance(this.cliente.customer);
      this.customerCreditBalance = customer;
    } catch (error) {
      console.error('Error loading customer credit balance:', error);
      this.customerCreditBalance = null;
    } finally {
      this.loadingCreditBalance = false;
    }
  }

  onClose() {
    this.closeModal.emit();
  }

  onReactivar() {
    const reactivationData = {
      cliente: this.cliente,
      option: this.selectedOption,
      lastInvoice: this.lastInvoice
    };
    this.reactivarCliente.emit(reactivationData);
  }

  // Prevent modal from closing when clicking inside the modal content
  onModalClick(event: Event) {
    event.stopPropagation();
  }

  getInvoiceStatusBadgeClass(status: string): string {
    switch (status) {
      case 'paid':
        return 'badge-success';
      case 'open':
        return 'badge-warning';
      case 'past_due':
        return 'badge-danger';
      case 'uncollectible':
        return 'badge-dark';
      case 'void':
        return 'badge-secondary';
      default:
        return 'badge-secondary';
    }
  }

  getInvoiceStatusText(status: string): string {
    switch (status) {
      case 'paid':
        return 'Pagado';
      case 'open':
        return 'Abierto';
      case 'past_due':
        return 'Vencido';
      case 'uncollectible':
        return 'Incobrable';
      case 'void':
        return 'Anulado';
      default:
        return status;
    }
  }

  formatCurrency(amount: number, currency: string = 'usd'): string {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: currency.toUpperCase()
    }).format(amount / 100); // Stripe amounts are in cents
  }

  formatDate(timestamp: number): string {
    return new Date(timestamp * 1000).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
}
